import { render, staticRenderFns } from "./ShippingUnitToAssign.vue?vue&type=template&id=a96875a2&scoped=true&"
import script from "./ShippingUnitToAssign.vue?vue&type=script&lang=ts&"
export * from "./ShippingUnitToAssign.vue?vue&type=script&lang=ts&"
import style0 from "./shippingUnitToAssign.scss?vue&type=style&index=0&id=a96875a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96875a2",
  null
  
)

export default component.exports